import { getIt } from "ap-components";
import Axios, { AxiosInstance } from "axios";
import { plainToInstance } from "class-transformer";
import { singleton } from "tsyringe";
import ActivationModel from "../Models/ActivationModel";
import SharedPrefs from "./SharedPrefs";


export const SERVER_URL = import.meta.env.REACT_APP_SERVER_URL ?? "";

@singleton()
export default class ActivationApis {
    instance: AxiosInstance = Axios.create({
        baseURL: SERVER_URL
    });

    constructor() {
        this.instance.interceptors.request.use(config => {
            return config;
        }, (err) => Promise.reject(err));

        this.instance.interceptors.response.use(e => e, err => {
            if (err.response.data.userMsg)
                err.message = err.response.data.userMsg;
            return Promise.reject(err);
        })
    }

    async digioRedirect(mandateId: string, { status, message }: { status: string, message?: string }): Promise<any> {
        var response = await this.instance.request({
            method: 'GET',
            url: `/hooks/nmandate/${mandateId}`,
            params: { status, message },
        });

        return response.data
    };

};